import { Grid } from "@mui/material";
import React from "react";
import { images } from "../../../../constants";
import QTDetailsImageWithLabelSection from "../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";
import { useAuth } from "../../../../hooks";

const AddAlbumDataFieldsSection = ({
  addAlbumsField,
  setAddAlbumsField,
  allAlbums,
  handleImagePreviewModalOpen,
  editEnabled,
  uploadImage,
  setUploadImage,
  setEditEnabled,
}) => {
  const { currentUser } = useAuth();

  // console.log("sdfjh", albumDetails);
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*photo section*/}
        <Grid item container direction={"column"} xs>
          <QTDetailsImageWithLabelSection
            label={"Album Photo"}
            // image={addAlbumsField?.images?.photoUrl}
            image={images.tableDummyImage}
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            editEnabled={editEnabled}
            uploadImage={uploadImage}
            details={addAlbumsField}
            setDetails={setAddAlbumsField}
            setUploadImage={setUploadImage}
            setEditEnabled={setEditEnabled}
          />
        </Grid>
        {/*ALbum Title section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Album Title"}
          name="title"
          id="title"
          value={addAlbumsField?.title}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAddAlbumsField((prevDetails) => ({
              ...prevDetails,
              title: e.target.value,
            }))
          }
        />
        {/*Created By section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Created By"}
          disabled={true}
          select={true}
          // value={addAlbumsField?.createdBy}
          value={currentUser?.firstName + " " + currentUser?.lastName}
          // onChange={(e) =>
          //   setAddAlbumsField((prevDetails) => ({
          //     ...prevDetails,
          //     createdBy: e.target.value,
          //   }))
          // }
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Description section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Album Description"}
          name="description"
          id="description"
          multiline={true}
          rows={4}
          value={addAlbumsField?.description}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAddAlbumsField((prevDetails) => ({
              ...prevDetails,
              description: e.target.value,
            }))
          }
        />
        {/* who Can Listen section*/}
        <Grid item container direction={"column"} xs>
          <QTDetailsTextFieldWithLabelSection
            label={"Who Can Listen"}
            value={addAlbumsField.privacy}
            disabled={true}
            editEnabled={editEnabled}
            select={true}
            dropdownValues={["Public", "Private", "Unlisted"]}
            onChange={(e) =>
              setAddAlbumsField((prevDetails) => ({
                ...prevDetails,
                privacy: e.target.value,
              }))
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddAlbumDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};
